import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const AcademicCapIcon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={1.5}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M4.26 10.147a60.436 60.436 0 00-.491 6.347A48.627 48.627 0 0112 20.904a48.627 48.627 0 018.232-4.41 60.46 60.46 0 00-.491-6.347m-15.482 0a50.57 50.57 0 00-2.658-.813A59.905 59.905 0 0112 3.493a59.902 59.902 0 0110.399 5.84c-.896.248-1.783.52-2.658.814m-15.482 0A50.697 50.697 0 0112 13.489a50.702 50.702 0 017.74-3.342M6.75 15a.75.75 0 100-1.5.75.75 0 000 1.5zm0 0v-3.675A55.378 55.378 0 0112 8.443m-7.007 11.55A5.981 5.981 0 006.75 15.75v-1.5" />
  </svg>
);

const PaletteIcon = () => (
  <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={1.5}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M12 21a9.004 9.004 0 008.716-6.747M12 21a9.004 9.004 0 01-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 017.843 4.582M12 3a8.997 8.997 0 00-7.843 4.582m15.686 0A11.953 11.953 0 0112 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0121 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0112 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 013 12c0-1.605.42-3.113 1.157-4.418" />
  </svg>
);

const MusicNoteIcon = () => (
  <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={1.5}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M9 9l10.5-3m0 6.553v3.75a2.25 2.25 0 01-1.632 2.163l-1.32.377a1.803 1.803 0 11-.99-3.467l2.31-.66a2.25 2.25 0 001.632-2.163zm0 0V2.25L9 5.25v10.303m0 0v3.75a2.25 2.25 0 01-1.632 2.163l-1.32.377a1.803 1.803 0 01-.99-3.467l2.31-.66A2.25 2.25 0 009 15.553z" />
  </svg>
);

const TrophyIcon = () => (
  <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={1.5}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M16.5 18.75h-9m9 0a3 3 0 013 3h-15a3 3 0 013-3m9 0v-3.375c0-.621-.503-1.125-1.125-1.125h-.871M7.5 18.75v-3.375c0-.621.504-1.125 1.125-1.125h.872m5.007 0H9.497m5.007 0a7.454 7.454 0 01-.982-3.172M9.497 14.25a7.454 7.454 0 00.981-3.172M5.25 4.236c-.982.143-1.954.317-2.916.52A6.003 6.003 0 007.73 9.728M5.25 4.236V4.5c0 2.108.966 3.99 2.48 5.228M5.25 4.236V2.721C7.456 2.41 9.71 2.25 12 2.25c2.291 0 4.545.16 6.75.47v1.516M7.73 9.728a6.726 6.726 0 002.748 1.35m8.272-6.842V4.5c0 2.108-.966 3.99-2.48 5.228m2.48-5.492a46.32 46.32 0 012.916.52 6.003 6.003 0 01-5.395 4.972m0 0a6.726 6.726 0 01-2.749 1.35m0 0a6.772 6.772 0 01-3.044 0" />
  </svg>
);

const BeakerIcon = () => (
  <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={1.5}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M9.75 3.104v5.714a2.25 2.25 0 01-.659 1.591L5 14.5M9.75 3.104c-.251.023-.501.05-.75.082m.75-.082a24.301 24.301 0 014.5 0m0 0v5.714c0 .597.237 1.17.659 1.591L19.8 15.3M14.25 3.104c.251.023.501.05.75.082M19.8 15.3l-1.57.393A9.065 9.065 0 0112 15a9.065 9.065 0 00-6.23-.693L5 14.5m14.8.8l1.402 1.402c1.232 1.232.65 3.318-1.067 3.611A48.309 48.309 0 0112 21c-2.773 0-5.491-.235-8.135-.687-1.718-.293-2.3-2.379-1.067-3.61L5 14.5" />
  </svg>
);

const ComputerIcon = () => (
  <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={1.5}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M9 17.25v1.007a3 3 0 01-.879 2.122L7.5 21h9l-.621-.621A3 3 0 0115 18.257V17.25m6-12V15a2.25 2.25 0 01-2.25 2.25H5.25A2.25 2.25 0 013 15V5.25m18 0A2.25 2.25 0 0018.75 3H5.25A2.25 2.25 0 003 5.25m18 0V12a2.25 2.25 0 01-2.25 2.25H5.25A2.25 2.25 0 013 12V5.25" />
  </svg>
);

const SparkleIcon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={1.5}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 00-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 003.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 003.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 00-3.09 3.09zM18.259 8.715L18 9.75l-.259-1.035a3.375 3.375 0 00-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 002.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 002.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 00-2.456 2.456zM16.894 20.567L16.5 21.75l-.394-1.183a2.25 2.25 0 00-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 001.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 001.423 1.423l1.183.394-1.183.394a2.25 2.25 0 00-1.423 1.423z" />
  </svg>
);

const QuoteIcon = () => (
  <svg className="w-10 h-10" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
    <path d="M4.583 17.321C3.553 16.227 3 15 3 13.011c0-3.5 2.457-6.637 6.03-8.188l.893 1.378c-3.335 1.804-3.987 4.145-4.247 5.621.537-.278 1.24-.375 1.929-.311 1.804.167 3.226 1.648 3.226 3.489a3.5 3.5 0 01-3.5 3.5c-1.073 0-2.099-.49-2.748-1.179zm10 0C13.553 16.227 13 15 13 13.011c0-3.5 2.457-6.637 6.03-8.188l.893 1.378c-3.335 1.804-3.987 4.145-4.247 5.621.537-.278 1.24-.375 1.929-.311 1.804.167 3.226 1.648 3.226 3.489a3.5 3.5 0 01-3.5 3.5c-1.073 0-2.099-.49-2.748-1.179z"/>
  </svg>
);

const subjects = [
  {
    id: 'art',
    label: 'Art',
    number: '01',
    Icon: PaletteIcon,
    palette: {
      accent: 'bg-purple-500',
      ring: 'ring-purple-100',
      iconBg: 'bg-purple-100',
      iconText: 'text-purple-700',
      badgeBg: 'bg-purple-50',
      badgeText: 'text-purple-700',
      badgeBorder: 'border-purple-200',
      gradient: 'from-purple-50 via-white to-white',
      glow: 'bg-purple-200/40',
    },
    images: [
      '/assets/images/artsmusic/28f94b94-f255-434e-a215-4e1d7490f6b4.jpg',
      '/assets/images/artsmusic/df9c8690-e69e-4a0a-ade3-d36738d3d60e.jpg',
    ],
    description:
      'Our art program sparks creativity for students in 3K through 5th grade. Kids learn to express themselves through hands-on projects, building real art techniques along the way. Ms. Wysong also leads an art club for middle schoolers and a parent-child after-school art class. She helps students create professional portfolios for high school admissions.',
  },
  {
    id: 'music',
    label: 'Music',
    number: '02',
    Icon: MusicNoteIcon,
    palette: {
      accent: 'bg-pink-500',
      ring: 'ring-pink-100',
      iconBg: 'bg-pink-100',
      iconText: 'text-pink-700',
      badgeBg: 'bg-pink-50',
      badgeText: 'text-pink-700',
      badgeBorder: 'border-pink-200',
      gradient: 'from-pink-50 via-white to-white',
      glow: 'bg-pink-200/40',
    },
    images: ['/assets/images/studentlife/Rauw_Alejandro.jpg'],
    description:
      "Ms. Heller brings rhythm, voice, and joy to every student from 3K to 5th grade. Our goal is to build a lifelong love of music while supporting each child's overall growth. Every year, families look forward to our Winter Concert, Black History Celebration Show, and Spring Concert, where our young musicians shine.",
  },
  {
    id: 'pe',
    label: 'Physical Education (PE)',
    number: '03',
    Icon: TrophyIcon,
    palette: {
      accent: 'bg-blue-500',
      ring: 'ring-blue-100',
      iconBg: 'bg-blue-100',
      iconText: 'text-blue-700',
      badgeBg: 'bg-blue-50',
      badgeText: 'text-blue-700',
      badgeBorder: 'border-blue-200',
      gradient: 'from-blue-50 via-white to-white',
      glow: 'bg-blue-200/40',
    },
    images: [
      '/assets/images/studentlife/3ce9c476-5aa6-45d4-b416-112331a384bd.jpg',
      '/assets/images/studentlife/87c5b9c0-829d-4898-b232-d8735463dde8.jpg',
    ],
    description:
      'PE at PS96 is all about movement, teamwork, and setting fun fitness goals. We believe staying active builds confidence, creativity, and lifelong health. Our goal is for every child to leave with healthy habits and a real love for being active.',
  },
  {
    id: 'science',
    label: 'Science',
    number: '04',
    Icon: BeakerIcon,
    palette: {
      accent: 'bg-emerald-500',
      ring: 'ring-emerald-100',
      iconBg: 'bg-emerald-100',
      iconText: 'text-emerald-700',
      badgeBg: 'bg-emerald-50',
      badgeText: 'text-emerald-700',
      badgeBorder: 'border-emerald-200',
      gradient: 'from-emerald-50 via-white to-white',
      glow: 'bg-emerald-200/40',
    },
    images: [
      '/assets/images/studentlife/4b610589-6c31-4d6d-aeae-09e7c0193c70.jpg',
      '/assets/images/studentlife/cf2bab93-70c8-4b39-8fbf-cc0ed91b11c9.jpg',
    ],
    description:
      'Students from kindergarten through 5th grade learn through hands-on, inquiry-based projects that build curiosity and critical thinking. Beyond the classroom, our Green Team lets students take action on climate and sustainability projects. Science is also a core course for grades 6–8, covering life science, earth and space science, and physical science each year.',
  },
  {
    id: 'technology',
    label: 'Technology',
    number: '05',
    Icon: ComputerIcon,
    palette: {
      accent: 'bg-amber-500',
      ring: 'ring-amber-100',
      iconBg: 'bg-amber-100',
      iconText: 'text-amber-700',
      badgeBg: 'bg-amber-50',
      badgeText: 'text-amber-700',
      badgeBorder: 'border-amber-200',
      gradient: 'from-amber-50 via-white to-white',
      glow: 'bg-amber-200/40',
    },
    images: [],
    description:
      'Every student at PS96 has an iPad for learning and creating. Our updated Mac computer lab gives students the tools for 21st-century learning.',
  },
];

const SubjectHeader = ({ subject }) => {
  const { Icon, palette } = subject;
  return (
    <div className="mb-6">
      <div className="flex items-center gap-4 mb-5">
        <div
          className={`w-14 h-14 rounded-2xl ${palette.iconBg} ${palette.iconText} flex items-center justify-center ring-8 ${palette.ring} shadow-sm`}
        >
          <Icon />
        </div>
        <div>
          <span className="block text-xs font-bold tracking-[0.18em] text-gray-500 uppercase">
            {subject.number} — Special Subject
          </span>
          <h2
            className="text-3xl lg:text-4xl font-semibold text-gray-900 tracking-tight mt-1"
            style={{ letterSpacing: '-0.02em' }}
          >
            {subject.label}
          </h2>
        </div>
      </div>
      <div className={`h-1 w-16 ${palette.accent} rounded-full`} />
    </div>
  );
};

const TextBlock = ({ subject }) => (
  <div className="flex flex-col justify-center">
    <SubjectHeader subject={subject} />
    <p className="text-gray-700 leading-relaxed text-lg">{subject.description}</p>
  </div>
);

const TwoImageCollage = ({ subject }) => (
  <div className="relative">
    {/* Soft color glow behind images */}
    <div
      className={`absolute -inset-6 ${subject.palette.glow} rounded-[2rem] blur-2xl -z-10`}
      aria-hidden="true"
    />
    <div className="grid grid-cols-5 grid-rows-6 gap-4 h-[28rem]">
      <div className="col-span-3 row-span-6 overflow-hidden rounded-2xl shadow-lg ring-1 ring-black/5">
        <img
          src={subject.images[0]}
          alt={`${subject.label} at PS 96`}
          className="w-full h-full object-cover"
          loading="lazy"
        />
      </div>
      <div className="col-span-2 row-span-3 row-start-2 overflow-hidden rounded-2xl shadow-lg ring-1 ring-black/5">
        <img
          src={subject.images[1]}
          alt={`${subject.label} at PS 96`}
          className="w-full h-full object-cover"
          loading="lazy"
        />
      </div>
    </div>
  </div>
);

const SingleImageBlock = ({ subject }) => (
  <div className="relative">
    <div
      className={`absolute -inset-6 ${subject.palette.glow} rounded-[2rem] blur-2xl -z-10`}
      aria-hidden="true"
    />
    <div className="overflow-hidden rounded-2xl shadow-lg ring-1 ring-black/5 aspect-[4/3]">
      <img
        src={subject.images[0]}
        alt={`${subject.label} at PS 96`}
        className="w-full h-full object-cover"
        loading="lazy"
      />
    </div>
  </div>
);

const ImageBlock = ({ subject }) =>
  subject.images.length === 2 ? <TwoImageCollage subject={subject} /> : <SingleImageBlock subject={subject} />;

const TextOnlyCard = ({ subject }) => {
  const { Icon, palette } = subject;
  return (
    <div
      className={`relative overflow-hidden rounded-3xl ${palette.badgeBg} border border-gray-200 p-10 lg:p-14 shadow-sm`}
    >
      {/* Decorative gradient blob */}
      <div
        className={`absolute -top-20 -right-20 w-72 h-72 ${palette.glow} rounded-full blur-3xl`}
        aria-hidden="true"
      />

      <div className="relative max-w-3xl">
        <div className="flex items-center gap-4 mb-6">
          <div
            className={`w-14 h-14 rounded-2xl ${palette.iconBg} ${palette.iconText} flex items-center justify-center ring-8 ${palette.ring} shadow-sm`}
          >
            <Icon />
          </div>
          <div>
            <span className="block text-xs font-bold tracking-[0.18em] text-gray-500 uppercase">
              {subject.number} — Special Subject
            </span>
            <h2
              className="text-3xl lg:text-4xl font-semibold text-gray-900 tracking-tight mt-1"
              style={{ letterSpacing: '-0.02em' }}
            >
              {subject.label}
            </h2>
          </div>
        </div>
        <div className={`h-1 w-16 ${palette.accent} rounded-full mb-6`} />
        <p className="text-gray-700 leading-relaxed text-lg">{subject.description}</p>
      </div>
    </div>
  );
};

const SubjectSection = ({ subject, imageRight }) => {
  if (subject.images.length === 0) {
    return (
      <section>
        <TextOnlyCard subject={subject} />
      </section>
    );
  }

  return (
    <section>
      <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        {imageRight ? (
          <>
            <TextBlock subject={subject} />
            <ImageBlock subject={subject} />
          </>
        ) : (
          <>
            <ImageBlock subject={subject} />
            <TextBlock subject={subject} />
          </>
        )}
      </div>
    </section>
  );
};

const SpecialSubjectsPage = () => {
  let imageRightCounter = 0;

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      <main id="main-content" className="pt-0">
        {/* Hero */}
        <section
          className="relative pt-36 pb-32 overflow-hidden bg-[#00213a]"
        >
          <div
            className="pointer-events-none absolute inset-x-0 bottom-0"
            style={{ height: '4rem', background: 'linear-gradient(to bottom, rgba(0,33,58,0) 0%, rgba(255,255,255,1) 100%)' }}
            aria-hidden="true"
          />

          {/* Decorative gradient orbs */}
          <div
            className="absolute top-20 -left-32 w-96 h-96 bg-[#fdbb2e]/10 rounded-full blur-3xl"
            aria-hidden="true"
          />
          <div
            className="absolute top-40 -right-32 w-96 h-96 bg-purple-500/10 rounded-full blur-3xl"
            aria-hidden="true"
          />

          <div className="relative max-w-5xl mx-auto px-6 lg:px-8 text-center">
            <div className="flex items-center justify-center gap-3 mb-6">
              <div className="flex items-center gap-2 px-4 py-2 bg-white/10 backdrop-blur-sm rounded-lg border border-white/20">
                <AcademicCapIcon />
                <span className="text-sm font-semibold text-white tracking-tight">Academics</span>
              </div>
            </div>
            <h1
              className="text-5xl lg:text-7xl font-semibold text-white mb-6 tracking-tight"
              style={{ letterSpacing: '-0.02em' }}
            >
              Special Subjects
            </h1>
            <p className="text-xl text-white/80 font-normal max-w-2xl leading-relaxed mx-auto">
              Explore the programs that make PS 96 a place where every student can discover their passion.
            </p>
          </div>
        </section>

        {/* Bold Intro Statement */}
        <section className="max-w-5xl mx-auto px-6 lg:px-8 mt-6 mb-24">
          <div className="relative rounded-3xl overflow-hidden shadow-xl bg-[#00213a]">
            <div className="relative px-8 py-14 lg:px-16 lg:py-16 text-center">
              <div className="flex justify-center mb-6 text-[#fdbb2e]/80">
                <QuoteIcon />
              </div>
              <p className="text-2xl lg:text-3xl font-bold text-white leading-relaxed max-w-4xl mx-auto"
                 style={{ letterSpacing: '-0.01em' }}>
                We don't just teach subjects — we{' '}
                <span className="text-[#fdbb2e]">inspire minds</span>,{' '}
                <span className="text-[#fdbb2e]">nurture talents</span>, and{' '}
                <span className="text-[#fdbb2e]">spark futures</span>. See what makes our Harlem school one of a kind.
              </p>
            </div>
          </div>
        </section>

        {/* Subject Sections */}
        <div className="max-w-7xl mx-auto px-6 lg:px-8 pb-24 space-y-28">
          {subjects.map((subject) => {
            const imageRight =
              subject.images.length > 0 ? imageRightCounter++ % 2 === 0 : false;
            return (
              <SubjectSection
                key={subject.id}
                subject={subject}
                imageRight={imageRight}
              />
            );
          })}
        </div>

        {/* Closing CTA */}
        <section className="relative py-20 bg-[#00213a] overflow-hidden">
          <div className="relative max-w-3xl mx-auto px-6 lg:px-8 text-center">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/10 backdrop-blur-sm rounded-lg border border-white/20 mb-6 text-white">
              <SparkleIcon />
              <span className="text-sm font-semibold tracking-tight">Where curiosity grows</span>
            </div>
            <h2
              className="text-4xl lg:text-5xl font-semibold text-white mb-6 tracking-tight"
              style={{ letterSpacing: '-0.02em' }}
            >
              A well-rounded education for every child
            </h2>
            <p className="text-lg text-white/80 leading-relaxed">
              From the art studio to the gym, from the science lab to the music room — every classroom at PS 96 is a place to learn, create, and grow.
            </p>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default SpecialSubjectsPage;
